import React from "react";
import { useTheme } from "../Theme/ThemeProvider.js";
import { ModalWrapper } from "./styles";
import { IoClose } from "react-icons/io5";

export default function QrCode({ onClose }) {
  const { isDarkMode } = useTheme();
  const storeTheme = isDarkMode ? "dark" : "light";

  return (
    <ModalWrapper>
      <div className="overlay" onClick={onClose}>
        <div className="modalContent">
          <div className="stickyCardPrimatio">
            <div className="containerTitle">
              <div className="qrcodeTitle">Baixe o app Primatio Vault</div>
              <IoClose className="closeIcon" />
            </div>
          </div>

          <div className="stickyCard">
            <div className="storeWrapper">
              <div className="storeBox">
                <div className="storeRow">
                  <div className="badgeContainer">
                    <img
                      src={`/assets/${storeTheme}/badge-apple-${storeTheme}.svg`}
                      alt="App Store badge"
                      className="storeBadge"
                    />
                  </div>
                </div>
                <div className="qrcodePlaceholder" />
              </div>

              <div className="storeBox">
                <div className="storeRow">
                  <div className="badgeContainer">
                    <img
                      src={`/assets/dark/badge-google-dark.png`}
                      alt="Google Play badge"
                      className="storeBadge"
                    />
                  </div>
                </div>
                <div className="qrcodePlaceholder" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
}
